// IMPORTS
import axios from 'axios'
import Db from '@/dixie.js'
import Swal from 'sweetalert2'
import Router from '@/router'
import mobiscroll from '@mobiscroll/javascript'

const swalWithBootstrapButtons = Swal.mixin({
	customClass: {
		confirmButton: 'btn btn-xs btn-danger',
		cancelButton: 'btn btn-xs'
	},
	buttonsStyling: false
})

// DEFINITIONS
const state = {
	user: null
}

const getters = {
	isLogged: (state) => { return (!!state.user) },
	authGetUser: (state) => { return state.user},
	isAdmin() {
		return state.user.tipoUsuario == 'Admin'
	},
	isRestaurant() {
		return state.user.tipoUsuario == 'Restaurant'
	},
	authToken: (state) => { 
		return (!!state.user && !!state.user.token)? state.user.token : null 
	}
}

const mutations = {
	authUpdate: (state, payload ) => {
		state.user = payload.user
		if(!payload.justLoad){
			delete payload.justLoad
			Db.configs.where('key').equalsIgnoreCase('user').delete().then(()=>{
				Db.configs.add({
					key: 'user',
					value: JSON.stringify(payload)
				})
			})
		}
	},
	accountClean: (state) => {
		state.processing = false
		Db.configs.where('key').equalsIgnoreCase('token').delete()
		Db.configs.where('key').equalsIgnoreCase('user').delete()
		state.token = null
		state.user = null
	}
}

const actions = {
	recoverFromDixie: async ({commit}) => {
		try {
			const user = await Db.configs.where('key').equalsIgnoreCase('user').first()
			if(!!user){
				let data2commit = JSON.parse( user.value );
				console.log("data2commit", data2commit)
				data2commit.justLoad = true
				commit('authUpdate', data2commit)
				return true;
			} else {
				return false;
			}
		} catch(e){
			console.error(e)
			mobiscroll.snackbar({
				display: 'top',
				theme: 'ios',
				message: 'Ocurrió un error obteniendo la respuesta: ' + e,
				color: 'warning',
				duration: 7000
			})
		}
		return false
	},
	authTryLogin: ( {commit}, payload ) => {
		return new Promise((success) => {
			axios.post('auth/trylogin', payload).then(response => {
				if(response.status){
					commit('authUpdate', response.data)
					success()
				} 
			})
		})
	},
	authTryLogout: ( {commit} ) => {
		swalWithBootstrapButtons.fire({
			title: '¿Seguro que deseas cerrar sesión y salir?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Finalizar sesión',
			cancelButtonText: 'Cancelar',
			reverseButtons: true
		}).then((result) => {
			if (result.value) {
				commit('accountClean')
				Router.push({name: 'Auth'})
				swalWithBootstrapButtons.fire(
					'¡Hasta pronto!',
					'Tu sesión ha sido terminada.',
					'success'
				)
			}
		})
	}
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};
